(function () {
  'use strict';
  var root = document.querySelector('[data-bma]');
  if (!root) return;
  var form = root.querySelector('[data-bma-form]');
  var alertBox = root.querySelector('[data-bma-alert]');
  var success = root.querySelector('[data-bma-success]');
  var submitBtn = root.querySelector('[data-bma-submit]');
  var submitLabel = root.querySelector('[data-bma-submit-label]');
  var PLATFORMS = ['instagram', 'tiktok', 'facebook', 'youtube'];
  var STATES = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];

  var rawBase = (root.getAttribute('data-api-base') || '').trim().replace(/\/+$/, '');
  var sameOrigin = root.getAttribute('data-preview-same-origin') === 'true';
  var API_BASE = rawBase || (sameOrigin ? '' : null);

  // One id per application attempt; reused for every retry, held in memory only.
  var submissionId = null;
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16); crypto.getRandomValues(b);
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }

  // Platform checkboxes enable their handle input.
  PLATFORMS.forEach(function (p) {
    var box = root.querySelector('[data-bma-platform="' + p + '"]');
    var input = form.elements[p];
    box.addEventListener('change', function () {
      input.disabled = !box.checked;
      if (box.checked) input.focus();
      clearErr('social');
    });
  });

  var recaptcha = API_BASE === null ? Promise.resolve(null) :
    fetch(API_BASE + '/api/contact/recaptcha', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.enabled || !d.siteKey) return null;
        var ready = new Promise(function (resolve, reject) {
          var s = document.createElement('script');
          s.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(d.siteKey);
          s.async = true;
          s.onload = function () { window.grecaptcha.ready(resolve); };
          s.onerror = function () { reject(new Error('recaptcha')); };
          document.head.appendChild(s);
        });
        var st = document.createElement('style');
        st.textContent = '.grecaptcha-badge{visibility:hidden}';
        document.head.appendChild(st);
        root.querySelector('[data-bma-recaptcha]').hidden = false;
        return { siteKey: d.siteKey, ready: ready };
      })
      .catch(function () { return null; });

  function token() {
    return recaptcha.then(function (cfg) {
      if (!cfg) return '';
      return cfg.ready.then(function () { return window.grecaptcha.execute(cfg.siteKey, { action: 'ambassador' }); });
    });
  }

  function errEl(key) { return root.querySelector('#bma-' + key + '-err'); }
  function setErr(key, msg, input) {
    var el = errEl(key);
    if (el) { el.textContent = msg; el.hidden = false; }
    if (input) input.setAttribute('aria-invalid', 'true');
  }
  function clearErr(key) {
    var el = errEl(key);
    if (el) { el.hidden = true; el.textContent = ''; }
    var input = form.elements[key];
    if (input && input.removeAttribute) input.removeAttribute('aria-invalid');
  }
  ['fullName', 'email', 'streetAddress', 'suburb', 'state', 'postcode'].forEach(function (k) {
    form.elements[k].addEventListener('input', function () { clearErr(k); });
  });
  form.elements.agreement.addEventListener('change', function () { clearErr('agreement'); });
  PLATFORMS.forEach(function (p) { form.elements[p].addEventListener('input', function () { clearErr('social'); }); });

  function val(k) { return (form.elements[k].value || '').trim(); }

  function validate() {
    var first = null;
    function bad(k, msg, input) { setErr(k, msg, input || form.elements[k]); first = first || input || form.elements[k]; }
    var name = val('fullName');
    if (name.length < 2) bad('fullName', 'Please enter your full name.');
    var email = val('email');
    if (!email) bad('email', 'Please enter your email address.');
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) bad('email', 'Please enter a valid email address.');
    if (val('streetAddress').length < 3) bad('streetAddress', 'Please enter your street address.');
    if (val('suburb').length < 2) bad('suburb', 'Please enter your suburb or town.');
    if (STATES.indexOf(val('state')) < 0) bad('state', 'Please choose your state or territory.');
    if (!/^[0-9]{4}$/.test(val('postcode'))) bad('postcode', 'Please enter a 4-digit Australian postcode.');
    var chosen = PLATFORMS.filter(function (p) { return !form.elements[p].disabled; });
    var filled = chosen.filter(function (p) { return val(p); });
    if (!filled.length) {
      var target = chosen.length ? form.elements[chosen[0]] : root.querySelector('[data-bma-platform="instagram"]');
      setErr('social', chosen.length ? 'Please enter your handle for the platform you ticked.' : 'Please tick at least one platform and add your handle.');
      if (chosen.length) target.setAttribute('aria-invalid', 'true');
      first = first || target;
    } else {
      var empty = chosen.filter(function (p) { return !val(p); });
      if (empty.length) { setErr('social', 'Add a handle for each ticked platform, or untick it.', form.elements[empty[0]]); first = first || form.elements[empty[0]]; }
    }
    if (!form.elements.agreement.checked) bad('agreement', 'Please tick the agreement to continue.');
    if (first) first.focus();
    return !first;
  }

  function showAlert(msg) { alertBox.textContent = msg; alertBox.hidden = false; }
  var busy = false;
  function setBusy(on) {
    busy = on;
    submitBtn.disabled = on;
    submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    submitLabel.textContent = on ? 'Submitting…' : 'Submit application';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    alertBox.hidden = true;
    if (!validate()) return;
    if (API_BASE === null) {
      showAlert('Applications can’t be submitted right now because the site’s application service isn’t configured. Please try again later or contact us.');
      return;
    }
    if (!submissionId) submissionId = uuid();
    setBusy(true);
    token().then(function (recaptchaToken) {
      var body = {
        submissionId: submissionId,
        fullName: val('fullName'), email: val('email'),
        streetAddress: val('streetAddress'), addressLine2: val('addressLine2'),
        suburb: val('suburb'), state: val('state'), postcode: val('postcode'),
        country: 'Australia',
        instagram: '', tiktok: '', facebook: '', youtube: '',
        agreement: true,
        website: form.elements.website.value || '',
        recaptchaToken: recaptchaToken || ''
      };
      PLATFORMS.forEach(function (p) { if (!form.elements[p].disabled) body[p] = val(p); });
      return fetch(API_BASE + '/api/bragmat/ambassador-applications', {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (d) { return { ok: r.ok, status: r.status, data: d }; });
      });
    }).then(function (res) {
      if (res.ok && res.data && res.data.saved === true) {
        form.hidden = true;
        success.hidden = false;
        success.focus();
        success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var msg = res.data && (res.data.error || res.data.message);
      setBusy(false);
      showAlert((res.status === 400 && msg ? msg + ' ' : 'Sorry, we couldn’t save your application. ') + 'Your details are still here — please check and try again.');
      alertBox.focus && alertBox.scrollIntoView({ block: 'center' });
    }).catch(function () {
      setBusy(false);
      showAlert('We couldn’t reach our server. Your details are still here — please try again.');
      alertBox.scrollIntoView({ block: 'center' });
    });
  });
})();
